module.exports = __webpack_public_path__ + "static/media/m_beard_stubble_oval_red.13b4438e.png";